(() => {
  if (window.VelveleCart) return;
  const isCart = value => value && Array.isArray(value.items) && typeof value.item_count === 'number';
  let state = JSON.parse(document.getElementById('velvele-cart-state').textContent);
  let revision = 0;
  const accept = value => { if (isCart(value)) { state = value; revision++; } };
  document.addEventListener('cart:change', event => accept(event.detail?.cart || event.detail));
  window.VelveleCart = {
    get current() { return state; },
    async refresh() {
      const version = ++revision;
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart state could not be refreshed');
      const cart = await response.json();
      if (!isCart(cart)) throw new Error('Invalid cart state');
      if (version === revision) {
        document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart }, bubbles: true }));
      }
      return state;
    }
  };
  document.addEventListener('cart:refresh', () => window.VelveleCart.refresh().catch(console.error));
  window.addEventListener('pageshow', event => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (event.persisted || navigation?.type === 'back_forward') {
      window.VelveleCart.refresh().then(cart => {
        document.querySelectorAll('cart-items, cart-drawer, cart-drawer-items, #main-cart-footer, .main-cart__wrapper')
          .forEach(element => element.classList.toggle('is-empty', cart.item_count === 0));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-history-restore' });
      }).catch(console.error);
    }
  });
  window.addEventListener('focus', () => window.VelveleCart.refresh().catch(console.error));
})();
